var map = {
	"./iconfont/demo.css": "./src/assets/iconfont/demo.css",
	"./iconfont/iconfont": "./src/assets/iconfont/iconfont.js",
	"./iconfont/iconfont.css": "./src/assets/iconfont/iconfont.css",
	"./iconfont/iconfont.eot": "./src/assets/iconfont/iconfont.eot",
	"./iconfont/iconfont.js": "./src/assets/iconfont/iconfont.js",
	"./iconfont/iconfont.json": "./src/assets/iconfont/iconfont.json",
	"./iconfont/iconfont.svg": "./src/assets/iconfont/iconfont.svg",
	"./iconfont/iconfont.ttf": "./src/assets/iconfont/iconfont.ttf",
	"./iconfont/iconfont.woff": "./src/assets/iconfont/iconfont.woff",
	"./iconfont/iconfont.woff2": "./src/assets/iconfont/iconfont.woff2",
	"./imgs/ai-chat-guide.png": "./src/assets/imgs/ai-chat-guide.png",
	"./imgs/diaBg.png": "./src/assets/imgs/diaBg.png",
	"./imgs/empty.png": "./src/assets/imgs/empty.png",
	"./imgs/error.png": "./src/assets/imgs/error.png",
	"./imgs/layout/layout-bg.png": "./src/assets/imgs/layout/layout-bg.png",
	"./imgs/login/login-1.png": "./src/assets/imgs/login/login-1.png",
	"./imgs/login/login-2.png": "./src/assets/imgs/login/login-2.png",
	"./imgs/login/login-3.png": "./src/assets/imgs/login/login-3.png",
	"./imgs/login/login-bg.png": "./src/assets/imgs/login/login-bg.png",
	"./imgs/login/login-copy.png": "./src/assets/imgs/login/login-copy.png",
	"./imgs/login/login.png": "./src/assets/imgs/login/login.png",
	"./imgs/logo-icon.png": "./src/assets/imgs/logo-icon.png",
	"./imgs/logo-icon1.png": "./src/assets/imgs/logo-icon1.png",
	"./imgs/logo.png": "./src/assets/imgs/logo.png",
	"./imgs/process-end.png": "./src/assets/imgs/process-end.png",
	"./imgs/tree-empty.png": "./src/assets/imgs/tree-empty.png",
	"./imgs/unpredictability.png": "./src/assets/imgs/unpredictability.png",
	"./imgs/user/blue_man.png": "./src/assets/imgs/user/blue_man.png",
	"./imgs/user/blue_woman.png": "./src/assets/imgs/user/blue_woman.png",
	"./imgs/user/end-of-process.png": "./src/assets/imgs/user/end-of-process.png",
	"./imgs/user/green_man.png": "./src/assets/imgs/user/green_man.png",
	"./imgs/user/green_woman.png": "./src/assets/imgs/user/green_woman.png",
	"./imgs/user/lakeBlue_man.png": "./src/assets/imgs/user/lakeBlue_man.png",
	"./imgs/user/lakeBlue_woman.png": "./src/assets/imgs/user/lakeBlue_woman.png",
	"./imgs/user/person.jpg": "./src/assets/imgs/user/person.jpg",
	"./imgs/user/purple_man.png": "./src/assets/imgs/user/purple_man.png",
	"./imgs/user/purple_woman.png": "./src/assets/imgs/user/purple_woman.png",
	"./imgs/user/red_man.png": "./src/assets/imgs/user/red_man.png",
	"./imgs/user/red_woman.png": "./src/assets/imgs/user/red_woman.png",
	"./imgs/user/user-default.png": "./src/assets/imgs/user/user-default.png",
	"./imgs/user/user-women.png": "./src/assets/imgs/user/user-women.png",
	"./imgs/user/yellow_man.png": "./src/assets/imgs/user/yellow_man.png",
	"./imgs/user/yellow_woman.png": "./src/assets/imgs/user/yellow_woman.png",
	"./imgs/welcome.png": "./src/assets/imgs/welcome.png",
	"./imgs/zx1.png": "./src/assets/imgs/zx1.png",
	"./imgs/zx2.png": "./src/assets/imgs/zx2.png",
	"./login_images/bg2-1.jpg": "./src/assets/login_images/bg2-1.jpg",
	"./login_images/kenvue.png": "./src/assets/login_images/kenvue.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";